import { lazy } from 'react';
import wait from './wait';
async function retry(moduleFn, retryOptions = {}, tryCount = 1) {
  const {
    maxRetryCount = 5,
    baseRetryIntervalMs = 500,
    simulateRetry = () => false
  } = retryOptions;
  try {
    if (simulateRetry() && tryCount <= maxRetryCount) {
      throw new Error('Promise rejected because simulating retry');
    }
    return await moduleFn();
  } catch (err) {
    if (tryCount <= maxRetryCount) {
      await wait(baseRetryIntervalMs * tryCount);
      return retry(moduleFn, retryOptions, tryCount + 1);
    }
    throw err;
  }
}

/**
 * @deprecated Use {@link https://www.npmjs.com/package/webpack-retry-chunk-load-plugin|webpack-retry-chunk-load-plugin} instead
 */
export function lazyWithRetry(moduleFn, retryOptions) {
  return /*#__PURE__*/lazy(() => retry(moduleFn, retryOptions));
}

/**
 * @deprecated Use {@link https://www.npmjs.com/package/webpack-retry-chunk-load-plugin|webpack-retry-chunk-load-plugin} instead
 */
export async function importWithRetry(moduleFn, retryOptions) {
  return retry(moduleFn, retryOptions);
}